import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GiftcardDetailsWeb from "./layouts/GiftcardDetails.web";
import GiftcardDetailsMob from "./layouts/GiftcardDetails.mob";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { useState } from "react";
import { useGetItemDetailsQuery } from "src/store/slices/item/item.api";
import { GiftcardDetailsHeader, GiftcardDetailsSkeleton } from "./components";
import NoData from "@Components/NoData/NoData";
import useGiftcardValue from "./hooks/useGiftcardValue";
import { toLanguage } from "src/i18n/direction";

const GiftcardDetailsComponent = withConditionalComponent(GiftcardDetailsWeb, GiftcardDetailsMob);

export default function GiftcardDetails() {
  const { code } = useParams();
  const { t, i18n } = useTranslation();
  const { data, isFetching, error } = useGetItemDetailsQuery({ moduleType: "GiftCards", PageSize: 10000, Page: 1, code, lang: toLanguage(i18n.language) }, { skip: !code });
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);
  const rawData = data?.items[selectedItemIndex];
  const { data: effectiveData, range, onRangeChange } = useGiftcardValue(rawData);

  return (
    <div className="bg-background-default flex w-full flex-1 flex-col items-start gap-5 p-6 md:p-10">
      <GiftcardDetailsHeader brandName={data?.brand} isFetching={isFetching} />
      {isFetching && (
        <div className="flex w-full flex-1 items-start justify-center md:p-5">
          <GiftcardDetailsSkeleton />
        </div>
      )}
      {!isFetching && error && (
        <div className="flex w-full flex-1 items-center justify-center">
          <NoData description={t("Giftcards.detailsUnavailable")} className="h-full w-full" />
        </div>
      )}
      {!isFetching && !error && data && rawData && (
        <div className="flex w-full flex-1 items-start justify-center md:p-5">
          <GiftcardDetailsComponent
            trigger={isLargeScreen}
            props={{
              data: effectiveData,
              imageUrl: data.imageUrl,
              itemCode: rawData.code,
              items: data.items,
              selectedItemIndex,
              setSelectedItemIndex,
              brandName: data.brand,
              range,
              onRangeChange,
            }}
          />
        </div>
      )}
    </div>
  );
}
